module.exports = __webpack_public_path__ + "akne_4_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/dermatologie/akne_4_before.jpg
// module id = 922
// module chunks = 0